import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const Image = Styled(
  createSvgIcon(
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4534 11.3064L12.3668 6.43309C11.6601 4.77976 10.3601 4.71309 9.48678 6.28643L8.22678 8.55976C7.58678 9.71309 6.39345 9.81309 5.56678 8.77976L5.42011 8.59309C4.56011 7.51309 3.34678 7.64643 2.72678 8.87976L1.58011 11.1798C0.773447 12.7798 1.94011 14.6664 3.72678 14.6664H12.2334C13.9668 14.6664 15.1334 12.8998 14.4534 11.3064Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.64673 5.33301C5.7513 5.33301 6.64673 4.43758 6.64673 3.33301C6.64673 2.22844 5.7513 1.33301 4.64673 1.33301C3.54216 1.33301 2.64673 2.22844 2.64673 3.33301C2.64673 4.43758 3.54216 5.33301 4.64673 5.33301Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
    "Image",
  ),
);

export default Image;
